import { LOCALES, type Locale } from '@shop/types';

import { cn } from '../lib/utils';

/** Переключатель языка контента; точка — на языке уже есть текст. */
export function LocaleTabs({
  value,
  onChange,
  filled,
}: {
  value: Locale;
  onChange: (locale: Locale) => void;
  filled?: (locale: Locale) => boolean;
}) {
  return (
    <div role="tablist" className="inline-flex rounded-md border p-0.5">
      {LOCALES.map((locale) => (
        <button
          key={locale}
          type="button"
          role="tab"
          aria-selected={value === locale}
          onClick={() => {
            onChange(locale);
          }}
          className={cn(
            'relative rounded px-3 py-1 text-xs font-medium uppercase',
            value === locale ? 'bg-primary text-primary-foreground' : 'hover:bg-accent',
          )}
        >
          {locale}
          {filled?.(locale) ? (
            <span className="absolute right-0.5 top-0.5 size-1.5 rounded-full bg-emerald-500" />
          ) : null}
        </button>
      ))}
    </div>
  );
}
